import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgRecordStart = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 42 42"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <circle
            cx={21}
            cy={21}
            r={20}
            fill="#fff"
            stroke="#fff"
            strokeWidth={2}
        />
        <circle cx={21} cy={21} r={8} fill="#C60101" />
    </svg>
)
const ForwardRef = forwardRef(SvgRecordStart)
const Memo = memo(ForwardRef)
export default Memo
